import { useMediaQuery } from '@material-ui/core';
import { useEffect, useState } from 'react';

const useClientReady = (): boolean => {
    // Start as false on both server and client to prevent hydration mismatch
    const [isClientReady, setIsClientReady] = useState(false);

    // Only runs client-side — signals that browser APIs are now available
    useEffect(() => {
        setIsClientReady(true);
    }, []);

    return isClientReady;
};

/**
 * A media query hook that avoids layout flicker by deferring results until client-side hydration.
 * Prevents initial false negatives from useMediaQuery during SSR,
 * which caused components to flicker or render incorrectly while the page was loading.
 */
export const useSSRMediaQuery = (query: string): boolean | undefined => {
    const isBrowserReady = useClientReady();
    const queryMatches = useMediaQuery(query);

    // Return undefined until client is ready to avoid rendering with incorrect media query results
    if (!isBrowserReady) {
        return;
    }
    return queryMatches;
};
